// extracted by mini-css-extract-plugin
export default {"toolbarWrapper":"CaseFormsToolbar_toolbarWrapper__W5BZR","toolbarIcon":"CaseFormsToolbar_toolbarIcon__fmXmI","lineWeightIcon":"CaseFormsToolbar_lineWeightIcon__636UA"};